<script>
  import { v4 as uuidv4 } from "uuid";
  import { gsap } from "gsap";
  import CharacteristicsBlock from "./CharacteristicsBlock.svelte";
  import { onMount } from "svelte";

  export let image = "the image";
  export let title = "the title";
  export let text = "the text";
  export let textOffset = "50%";
  export let title2 = "the title";
  export let text2 = "the text";
  export let textOffset2 = "50%";
  export let title3 = "the title";
  export let text3 = "the text";
  export let textOffset3 = "50%";
  export let title4 = "the title";
  export let text4 = "the text";
  export let textOffset4 = "50%";
  export let dark = false;

  const componentId = "characteristics__" + uuidv4();
  let block1Component;
  let block2Component;
  let block3Component;
  let block4Component;
  let blocks;

  function handleClick(blockIndex) {
    return function (event) {
      for (let i = 0; i < blocks.length; i++) {
        if (blockIndex - 1 !== i) {
          blocks[i].hide();
        } else {
          blocks[i].show();
        }
      }
    };
  }

  onMount(() => {
    blocks = [
      block1Component,
      block2Component,
      block3Component,
      block4Component,
    ];

    const tl = gsap.timeline();
    tl.to(
      "#" +
        componentId +
        " .characteristics__block-3 .characteristics-block__separator-box",
      {
        opacity: 1,
        duration: 0.1,
      }
    );
    tl.to(
      "#" +
        componentId +
        " .characteristics__block-3 .characteristics-block__separator-target .target",
      {
        scale: 1.1,
        boxShadow: !dark
          ? "0 0 8px 8px #869ac390 inset, 0 0 8px 8px #869ac390"
          : "0 0 8px 8px #af6d2290 inset, 0 0 8px 8px #af6d2290",
        duration: 0.01,
      },
      "<"
    );
    tl.to(
      "#" +
        componentId +
        " .characteristics__block-3 .characteristics-block__text",
      {
        opacity: 1,
        duration: 0.2,
      },
      ">-0.05"
    );
    tl.play();
  });
</script>

<div id={componentId} class="characteristics__pin-container">
  <div class="characteristics__container">
    <div class="characteristics">
      <div class="characteristics__image">
        <img src={image} />
      </div>
      <div
        class="characteristics__block characteristics__block-1"
        class:characteristics__block--dark={dark}
      >
        <CharacteristicsBlock
          bind:this={block1Component}
          {textOffset}
          {title}
          {text}
          {dark}
          inverted={true}
          on:click={handleClick(1)}
        />
      </div>
      <div
        class="characteristics__block characteristics__block-2"
        class:characteristics__block-2--dark={dark}
      >
        <CharacteristicsBlock
          bind:this={block2Component}
          textOffset={textOffset2}
          title={title2}
          text={text2}
          inverted={true}
          {dark}
          on:click={handleClick(2)}
        />
      </div>
      <div
        class="characteristics__block characteristics__block-3"
        class:characteristics__block-3--dark={dark}
      >
        <CharacteristicsBlock
          bind:this={block3Component}
          textOffset={textOffset3}
          title={title3}
          text={text3}
          {dark}
          on:click={handleClick(3)}
        />
      </div>
      <div
        class="characteristics__block characteristics__block-4"
        class:characteristics__block-4--dark={dark}
      >
        <CharacteristicsBlock
          bind:this={block4Component}
          textOffset={textOffset4}
          title={title4}
          text={text4}
          {dark}
          on:click={handleClick(4)}
        />
      </div>
    </div>
  </div>
</div>

<style lang="scss">
  @import "./assets/styles/variables";
  @import "./assets/styles/animations";

  .characteristics {
    padding: 8rem 0;
    position: relative;
    width: 100%;

    &__pin-container {
      height: auto;
    }

    &__container {
      align-items: center;
      display: flex;
      height: 600px;

      @media screen and (min-width: $breakpoint-small) {
        height: 800px;
      }

      @media screen and (min-width: $breakpoint-medium) {
        height: 750px;
      }

      @media screen and (min-width: $breakpoint-large) {
        height: 800px;
      }
    }

    &__image {
      img {
        width: 100%;
      }
    }

    &__block {
      display: flex;
      height: 39%;
      justify-content: stretch;
      left: 28%;
      padding-bottom: 2rem;
      position: absolute;
      top: 0;
      width: 66%;

      &--dark {
        height: 62.5%;
        left: 16%;
        top: 0;
      }

      &-2 {
        bottom: unset;
        height: 42%;
        left: 15%;
        top: 0;

        &--dark {
          bottom: unset;
          height: 60%;
          left: 24%;
          top: 0;
        }
      }

      &-3 {
        bottom: 0;
        height: auto;
        left: 30%;
        top: 47%;

        &--dark {
          bottom: 0;
          height: auto;
          left: 20%;
          top: 60%;
        }
      }

      &-4 {
        bottom: 0;
        height: auto;
        left: 26%;
        top: 61%;

        &--dark {
          bottom: 0;
          height: auto;
          left: 6%;
          top: 60%;
        }
      }
    }
  }
</style>
